// Placeholder registry for MyFinancesGuru article links used in "related reading"
// sections. NONE are invented — fill in real URLs from myfinancesguru.com.
// Each calculator references article keys; unknown/empty keys simply render nothing.

export const MAIN_SITE_URL = "https://myfinancesguru.com";

// Map a friendly key -> { title, url }. Leave url "" until you paste the real link.
export const ARTICLES = {
  // "tfsa-guide": { title: "The Complete Canadian TFSA Guide", url: "" },
  // "rrsp-basics": { title: "RRSP Basics for Beginners", url: "" },
  // "mortgage-101": { title: "Canadian Mortgage 101", url: "" },
};

export const getArticle = (key) => {
  const a = ARTICLES[key];
  if (!a || !a.url) return null;
  return a;
};
